import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const adminNavItems = (t) => [
  { to: '/dashboard', label: t('nav.dashboard'), icon: 'dashboard', end: true },
  { to: '/admin/statistics', label: t('nav.statistics') || 'Statistika', icon: 'bar_chart' },
  { to: '/admin/trucks', label: t('nav.trucks'), icon: 'local_shipping' },
  { to: '/admin/routes', label: t('nav.routes'), icon: 'alt_route' },
  { to: '/admin/queue', label: t('nav.queue'), icon: 'hourglass_empty' },
  { to: '/admin/cylinders', label: t('nav.cylinders'), icon: 'propane_tank' },
  { to: '/admin/payments', label: t('nav.payments'), icon: 'payments' },
  { to: '/admin/users', label: t('nav.users'), icon: 'group' },
  { to: '/admin/driver-tracking', label: t('nav.tracking'), icon: 'location_on' },
];

export function Sidebar() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const items = adminNavItems(t);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="fixed left-0 top-0 z-40 hidden xl:flex flex-col w-64 h-screen bg-white border-r border-[var(--border-strong)] shadow-[var(--shadow-lg)] py-6">
      <div className="px-6 pb-7 flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] flex items-center justify-center text-white shadow-[var(--shadow-glow-green)]">
          <span className="material-symbols-outlined text-[23px]" style={{ fontVariationSettings: "'FILL' 1" }}>propane_tank</span>
        </div>
        <div>
          <div className="sg-wordmark text-[19px] leading-none">Smart<em>Gaz</em></div>
          <div className="text-[9px] font-black uppercase tracking-[0.16em] text-[var(--fg4)] mt-0.5">Admin Console</div>
        </div>
      </div>

      <nav className="flex-1 flex flex-col gap-1 px-3 overflow-y-auto custom-scrollbar">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-[var(--radius-md)] text-sm transition-all duration-150 border-none ${
                isActive
                  ? 'bg-[var(--brand-green)] text-white shadow-[var(--shadow-glow-green)]'
                  : 'text-[var(--fg2)] hover:bg-[var(--bg-subtle)]'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className="material-symbols-outlined text-[20px]"
                  style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
                >
                  {item.icon}
                </span>
                <span className={`${isActive ? 'font-extrabold' : 'font-semibold'}`}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto px-3 pt-4 border-t border-[var(--border)] flex flex-col gap-1">
        <NavLink
          to="/settings"
          className="flex items-center gap-3 px-4 py-3 rounded-[var(--radius-md)] text-sm font-semibold text-[var(--fg2)] hover:bg-[var(--bg-subtle)] transition-colors"
        >
          <span className="material-symbols-outlined text-[20px]">settings</span>
          {t('settings.title')}
        </NavLink>
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 rounded-[var(--radius-md)] text-sm font-bold text-[var(--accent-red)] hover:bg-red-50 transition-colors text-left w-full"
        >
          <span className="material-symbols-outlined text-[20px]">logout</span>
          {t('profileModal.logout')}
        </button>
      </div>
    </aside>
  );
}
